import React, { Component, useId } from 'react';
import { Tabs, Table, Popconfirm, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';
import UserSider from '../UserSider';
import { tableColumns, tabs } from './pageMes';
import TableC from '../../basicElement/TableC';
import Filter from './components/Filter';
import MainScoreDetail from './components/MainScoreDetail';
import AddScoreDetail from './components/AddScoreDetail';
import MinusScoreDetail from './components/MinusScoreDetail';
import Update from './components/Update';
import fp from '../../../utils/fp';


const TabPane = Tabs.TabPane;
class CrcPostRank extends Component {

    state = {
        activeKey: '1',
        loading: false,
        pagination: {
            current: 1,
            pageSize:10,
        },
        searchParams: {},
        data: [],
        detailData: [],
        expandedRowKeys: [],
        menuType:'',
    }

    componentDidMount(){
        const { curRole } = sessionStorage;
        if(curRole == 'CRCC' || curRole == 'CRCM'){
            this.setState({ activeKey: '2' },()=>{
                this.handleTabClick(this.state.activeKey);
            })
        }
    }

    filterDataWithoutObject = (params) => {
        const obj = {};
        for (let [key, value] of Object.entries(params)) {
            if (typeof value !== 'object') {
                obj[key] = value;
            }
        }
        return obj;
    }

    loadData = () =>{
        this.setState({ loading: true });
        const { pagination:{ current, pageSize }, pagination, searchParams, menuType, activeKey } = this.state;
        const { areaParams = {} } = searchParams;
        
        const params = this.filterDataWithoutObject(searchParams);
        
        const options = {
            method: 'POST',
            url:  activeKey === '1' ? API_URL.user.queryCrcPostScoreList : API_URL.user.queryPositionCrcList,
            data: {
                limit:pageSize,
                offset: current,
                ...params,
                ...areaParams,
                menuType,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    onExpand = (expanded, record) => {
        const { expandedRowKeys } = this.state;
        if (!expanded) {
            expandedRowKeys.splice(0, 1);
        } else {
            expandedRowKeys[0] = record.index;
            this.queryDataList(record)
        }
        this.setState({ expandedRowKeys });
    }

    queryDataList = (record) => {
        const { menuType } = this.state;
        const { userId, userCompellation, employeeCode } = record;
        const options = {
            method: 'POST',
            url: API_URL.user.queryPositionCrcDetailList,
            data: {
                menuType,
                userId
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                datas.forEach( (el, index) => {
                    el.index = index + 1;
                    el.employeeCode = employeeCode;
                    el.userCompellation = userCompellation;
                    el.fileList = [];
                    (el.crcPostFileMetas || []).forEach((item, id) => {
                        const { name, fileMetaId } = item;
                        el.fileList.push({
                            name,
                            response: { fileMetaId: fileMetaId },
                            uid: id,
                        })
                    })
                })
                this.setState({
                    detailData: datas,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleTabClick = activeKey => {
        this.setState({ 
            activeKey, 
            expandedRowKeys:[], 
            menuType: activeKey === '1' ? null: tableColumns[activeKey].menuType 
        },activeKey === '1' ? () => {
            this.filterRef.queryRecentRecordTime()
            this.filterRef.initialize()
        }
        : () =>{
            this.filterRef.initialize()
            this.search()
        });
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params},
        }, () => {
            this.loadData();
        });
    }

    handleSubmit = (record, expandedRowKey) =>{
        const { expandedRowKeys } = this.state;
        expandedRowKeys[0] = expandedRowKey ? expandedRowKey[0] : record.index;
        this.setState({ expandedRowKeys }, () => this.queryDataList(record));
    }

    //导出
    export = () => {
        const { searchParams, menuType, activeKey } = this.state;
        const { areaParams = {} } = searchParams;
        const params = this.filterDataWithoutObject(searchParams);
        ExportUtil.export({ ...params, ...areaParams, menuType }, null, activeKey === '1' ? API_URL.user.exportCrcPostScoreList : API_URL.user.exportCrcPost);
    }

    //下载附件
    downLoadFile = (fileMetaId) => {
        const url = API_URL.user.downloadFileMeta;
        ExportUtil.export({fileMetaId}, null, url);
    }

    //排名总览
    getColumns = () => {
        const columns = [
        {
            title: '时间',
            dataIndex: 'recordYearMonth',
            key: 'recordYearMonth',
            width: 120,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 120,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 120,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 100,
        }, {
            title: '状态',
            dataIndex: 'workStatus',
            key: 'workStatus',
            width: 80,
            render: text => text ? text === 'WORKING' ? '在职' : '离职' :''
        }, {
            title: '排名',
            dataIndex: 'item',
            key: 'item',
            width: 80,
        }, {
            title: '总分',
            dataIndex: 'total',
            key: 'total',
            width: 80,
        }, {
            title: '主要技能分',
            dataIndex: 'mainPoint',
            key: 'mainPoint',
            width: 80,
            render: (text, record) => <a onClick={() => this.mainScoreDetailShow(record)}>{text}</a>
        }, {
            title: '加分',
            dataIndex: 'addPoint',
            key: 'addPoint',
            width: 80,
            render: (text, record) => <a onClick={() => this.addScoreDetailShow(record)}>{text}</a>
        }, {
            title: '减分',
            dataIndex: 'minusPoint',
            key: 'minusPoint',
            width: 80,
            render: (text, record) => <a onClick={() => this.minusScoreDetailShow(record)}>{text}</a>
        }];
        return columns;
    }

    getDetailColumns = () => {
        const columns = [
            {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 80,
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 80,
            }, {
                title: '职位/级别',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 120,
            }, {
                title: '工作城市',
                dataIndex: 'workCity',
                key: 'workCity',
                width: 80,
            }, {
                title: '主管领导工号',
                dataIndex: 'leaderCode',
                key: 'leaderCode',
                width: 100,
            }, {
                title: '主管领导姓名',
                dataIndex: 'leaderName',
                key: 'leaderName',
                width: 100,
            }, {
                title: '状态',
                dataIndex: 'workStatus',
                key: 'workStatus',
                width: 80,
                render: text => text ? text === 'WORKING' ? '在职' : '离职' :''
            }, {
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                width: 260,
                render: (text, record) =>{
                    const { activeKey, allowEnter } = this.state;
                    const { curRole } = sessionStorage;
                    let option = '-';
                    if(record.allowEnter && fp.contains(curRole, ['CRCM', 'CRCC', 'BO', 'CSAL']) ){
                        option = <a onClick={ () => this.updateShow(record) }>{ tableColumns[activeKey].option }</a>
                    }
                    return option
                }
            }];
            return columns;
    }

    getData = data => {
        data.forEach((el, index) => {
            el.index = index;
        })
        return data
    }

    mainScoreDetailShow = record => {
        this.mainScoreDetailRef.show(record)
    }

    //加分说明
    addScoreDetailShow = record => {
        this.addScoreDetailRef.show(record)
    }

    //减分说明
    minusScoreDetailShow = record => {
        this.minusScoreDetailRef.show(record)
    }
    
    updateShow = ( record = {}, isEdit = false, expandedRowKeys = null ) => {
        this.updateRef.show(record, isEdit, expandedRowKeys)
    }

    handleTableChange = params => {
        this.setState({
            pagination:params.pagination ? {...params.pagination} : {...params},
        }, () => {
            this.loadData();
        });
    }

    delete = record =>{
        const { activeKey, menuType } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.user.deleteCrcPost,
            data: {
                menuType,
                id: record[tableColumns[activeKey].submitId],
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success)
                this.queryDataList(record)
            },
        };
        $.sendRequest(options);
    }


    expandedRowRender = (record) => {
        const { activeKey, detailData, expandedRowKeys } = this.state;
        const { allowEnter } = record;
        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '时间',
                dataIndex: 'time',
                key: 'time',
                width: tableColumns[activeKey].timeWidth || 120,
                render: (text, record) => {
                    const { beginYearMonth, endYearMonth, date } = record;
                    return date ? date.slice(0, 10) : `${beginYearMonth}-${endYearMonth}`
                }
            }];
            columns.push(
                ...tableColumns[activeKey].childTable,
                )
            tableColumns[activeKey].tableFile && columns.push(
                {
                    title: '附件',
                    key:'crcPostFileMetas',
                    dataIndex: 'crcPostFileMetas',
                    render: (text, record) => {
                        const fileList = text && text.length ? text.map((element, index) => {
                            return <span key={index}>
                                    <a onClick={() => this.downLoadFile(element.fileMetaId)}>{element.name}</a>
                                    <br />
                                </span>
                        }) : '-'
                        return fileList
                    }
                },
            )
            columns.push(
                {
                    title: '操作',
                    dataIndex: 'option',
                    key: 'option',
                    width: 120,
                    render: (text, record) =>{
                        const { curRole } = sessionStorage;
                        let option = '-';
                        if(fp.contains(curRole, ['CRCM', 'CRCC', 'BO', 'CSAL'])){
                            option = <span>
                                <a onClick={ () => this.updateShow(record, true, expandedRowKeys) }>修改</a>
                                <span> | </span>
                                <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.delete(record)} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        }
                        return option
                    }
                }
            )
            return columns;
        }

        return (
            <Table
                rowKey={record => record.index}
                columns={getColumns()}
                dataSource={detailData}
                pagination={false}
            />
        );
    }

    render() {
            const { activeKey, loading, data, pagination, expandedRowKeys, menuType } = this.state;
            const { curRole } = sessionStorage;
        return (
            <div className="content">
                <UserSider selectKey='crcPostRank' openKeys={['sub3']}/>
                <div className="main contract-record">
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {tabs.map(pane => {
                            if(curRole == 'CRCC' || curRole == 'CRCM'){
                                if(pane.tab !== '排名总览'){
                                    return <TabPane tab={pane.tab} key={pane.key}></TabPane>
                                }
                            }else {
                                return <TabPane tab={pane.tab} key={pane.key}></TabPane>
                            }
                        })}
                    </Tabs>
                    {
                        activeKey !== '1' && <div style={{color:'red'}}>{`注意：${tableColumns[activeKey].attention}`}</div>
                    }
                    <Filter search={this.search} export={this.export} activeKey={activeKey} ref={ el => this.filterRef = el }/>
                    
                    {
                        activeKey === '1' ?
                        <TableC
                            loading={loading}
                            data={this.getData(data)}
                            pagination={pagination}
                            columns={this.getColumns()}
                            onChange={this.handleTableChange}
                        />:
                        <Table
                            loading={loading}
                            dataSource={this.getData(data)}
                            pagination={pagination}
                            rowKey={record => record.index}
                            columns={this.getDetailColumns()}
                            onChange={this.handleTableChange}
                            expandedRowKeys={expandedRowKeys}
                            onExpand={this.onExpand}
                            expandedRowRender={this.expandedRowRender}
                        />
                    }
                </div>
                <MainScoreDetail ref={ el => this.mainScoreDetailRef = el } />
                <AddScoreDetail ref={ el => this.addScoreDetailRef = el } />
                <MinusScoreDetail ref={ el => this.minusScoreDetailRef = el } />
                {
                    activeKey !== '1' && 
                    <Update ref={ el => this.updateRef = el } activeKey={activeKey}  menuType={menuType} search={this.handleSubmit}/>
                }
            </div>
        );
    }
}

export default  CrcPostRank


// WEBPACK FOOTER //
// ./src/components/user/crcPostRank/index.js